const alertsPage = {
  en: {
    alerts: {
      title: 'Alerts',
      searchInputPlaceholder: 'Start typing patient name...',
      showClosedCheckbox: 'Show closed',
      tableDateHeader: 'Recorded date',
      tablePatientHeader: 'Patient name',
      tableAlertHeader: 'Alert',
      tableNoteHeader: 'Note',
      tableStatusHeader: 'Current status',
      noMoreData: 'No more data',

      filters: {
        title: 'Filter',
        community: 'Locations',
        alertType: 'Alert type',
        vitalTypes: 'Vital types',
        alertLevels: 'Alert levels',
        errorMsg: 'Something went wrong',
        showBtn: 'Show',
        hideBtn: 'Hide',
      },
      alert: {
        title: 'Alerts for {msg}',
        statusUpdatedMsg: 'Alert status was updated',
        info: {
          title: 'Alert details',
          patient: 'Patient',
          patientDoB: 'Date of birth',
          alertType: 'Alert type',
          alertLevel: 'Alert level',
          lastUpdate: 'Last sensor update',
        },
        alertStatus: {
          title: 'Alert status',
          open: 'Requested',
          reviewing: 'In review',
          pendingTasks: 'Pending tasks',
          resolved: 'Resolved',
          openBtn: 'Acknowledge',
          pendingTasksText:
            'There are pending tasks which need to be resolved. Once done, the alert status will automatically change to “Completed”.',
          openText:
            'Once you “Acknowledge” you admit the immediate assistance is provided to the patient. Find the form to resolve under “Additional information” block.',
          reviewingText:
            'You acknowledged the alert, don’t forget to write closing notes with the summary to conclude it. By clicking “Complete”, you admit that you resolved the alert.',
          reviewingBtn: 'Complete',
          resolvedText: 'Alert is fully resolved. You can view summary notes if needed.',
        },

        completeForm: {
          titles: {
            summaryAlert: 'Summary of the alert*',
            sendToER: 'Sent to the ER?*',
            erElegible: 'ER (Emergency Room) eligible?*',
            instructionForLocation: 'Instructions for the location*',
            labOrdered: 'Labs ordered?*',
            imagesOrdered: 'Images (X-Ray) ordered?*',
            followUp: 'Follow-up visit needed?*',
          },
          subtitles: {
            locationNotes: 'Notes:',
            labOrderedDetails: 'Lab order details:',
            imagesOrderedDetails: 'Imaging order details:',
            followUpType: 'Type of follow-up*',
            selectCadence: 'Select cadence of checking:*',
            followUpDescription: 'Description:*',
            followUpPrivateNote: 'Private note:',
          },
          placeholders: {
            location: 'What you are requesting the location to do for the patient.',
            summaryAlert: 'Please share any specific information that might be important',
            hours: 'Hours',
            minutes: 'Minutes',
            followUpDesc: 'Who to follow up with and what follow up is needed',
          },
          labels: {
            description: 'Description:*',
            privateNote: 'Private notes:',
          },
          radioBtnLabel: {
            yes: 'Yes',
            no: 'No',
            phoneUpdate: 'Phone update',
            videoVisit: 'Video visit',
            none: 'None of above',
          },
          validation: {
            required: 'Required',
            incorrectEmail: 'Incorrect email',
            incorrectPhone: 'Incorrect phone number',
            atLeast20characters: 'Please enter at least 20 characters',
            atLeast2characters: 'Please enter at least 2 characters',
          },
          updateBtn: 'Update',
          completeBtn: 'Complete',
          cancelBtn: 'Cancel',
        },
        summary: {
          editBtn: 'Edit',
          alertSummary: 'Summary of the alert',
          locationInstructions: 'Location instructions',
          orderedAssets: 'Ordered assets',
          followUp: 'Follow-up visit needed?',
          internalNote: 'Internal note',
          er: 'Emergency room',
          erEligible: 'ER eligible',
          images: 'Images (X-Ray)',
          labs: 'Labs ordered?',
        },
      },
    },
  },
}
export default alertsPage
